import { mapGetters } from 'vuex';

export default {
    name: 'mvtCardSchool',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        onSwitchSchoolBoundary: {
            type: Function,
            default: () => {},
        },
    },
    methods: {
        switchSchoolBoundary() {
            if (this.isActive) {
                this.$eventBus.$emit('searchMap.schoolBoundaryUpdate', null);
            } else {
                this.$eventBus.$emit('searchMap.schoolBoundaryUpdate', this.data);
                this.$eventBus.$emit('propertyPopMap.schoolBoundaryUpdate', this.data);
            }
            this.$eventBus.$emit('close-popover');
            if (this.onSwitchSchoolBoundary) {
                this.onSwitchSchoolBoundary();
            }
        },
        greatSchoolUrl() {
            let externalUrl = this.data.externalUrls && this.data.externalUrls.filter((item) => item.type === 'School Overview');
            return externalUrl && externalUrl.length ? externalUrl[0].url : null;
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        rating() {
            let rate = parseInt(this.data.rating);
            let cls = '';
            if (isNaN(rate) || rate == 0) {
                cls = 'null';
                rate = 'NR';
            } else if (rate <= 3) {
                cls = 'poor';
            } else if (rate <= 7) {
                cls = 'fair';
            } else {
                cls = 'good';
            }
            cls += ' rate-' + rate;
            return { rate: rate, cls: cls };
        },
        getLevel() {
            if (this.data.level) {
                return 'Grades ' + this.data.level;
            }
            return '';
        },
        getRating() {
            let rate = this.rating.rate;
            return rate === 'NR' ? 'This school is not rated.' : rate + ' out of 10';
        },
        isActive() {
            return this.options.isActive;
        },
        showFooter() {
            return this.data.boundaryId && !this.options.hideFooter;
        },
    },
};
